export default "__VITE_ASSET__DdOKeQpL__"